export default "__VITE_ASSET__BxhglVSX__"